import AppRouter from "./utils/AppRouter";

const App = () => {
  return <div className="App">
    <AppRouter/>
  </div>;
};

export default App;
